import Image from "next/image";
import React from "react";

import CheckedIcon from "app/compare/checked-circle.svg";
import { displayModelName } from "app/compare/utils";
import { applyCDNToUrl } from "ui/StrapiImage";
import { useI18n } from "utils/with-i18n.utils";

import { ComparatorWinner } from "./ComparatorHelper";
import { ComparedModel } from "./[match]";

type Props = {
  left: ComparedModel;
  right: ComparedModel;
  winner?: ComparatorWinner;
};

export const Winner = ({ left, right, winner }: Props) => {
  const i18n = useI18n();

  if (!winner) {
    return null;
  }

  return (
    <section className="flex flex-col-reverse items-center mx-auto w-full max-w-[950px] bg-gradient-to-tr from-[#B492FF] to-[#4461C8] rounded-md md:flex-row md:items-end">
      <div className="flex justify-end items-end md:w-2/5">
        <div className="overflow-hidden h-56">
          <Image
            src={
              applyCDNToUrl(
                left.product?.slug.replace("/", "") === winner.slug
                  ? left.product?.picture.medium
                  : right.product?.picture.medium,
              ) ?? ""
            }
            alt="compare"
            width={255}
            height={343}
          />
        </div>
      </div>

      <div className="p-8 w-fit text-white md:w-3/5">
        <h2 className="mb-3 text-2xl font-bold">
          {i18n.t("comparator.winnerTitle", {
            model: displayModelName(winner.slug, true),
          })}
        </h2>
        <div className="flex flex-col gap-3">
          {winner.highlights.map((highlight: any, index: number) => (
            <div key={index}>
              <div className="flex gap-2 items-center">
                <CheckedIcon />
                <h3 className="leading-3">{highlight.name}</h3>
              </div>
              <p className="mt-1 ml-5 text-lg">
                <span className="font-bold">
                  {highlight.value.split(" vs ")[0]}
                </span>
                {highlight.value.split(" vs ")[1] && (
                  <span className="mx-1 text-white/75">vs</span>
                )}
                <span className="text-white/75">
                  {highlight.value.split(" vs ")[1]}
                </span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
